import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector     : 'wtf-navbar-horizontal',
    templateUrl  : './navbar-horizontal.component.html',
    styleUrls    : ['./navbar-horizontal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class WtfNavbarHorizontalComponent implements OnInit
{
    constructor()
    {
    }

    ngOnInit()
    {

    }
}
